import { ChangeDetectionStrategy, Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { TwitterInterface } from "../../../@core/models/site-data.model";
import * as Sentry from "@sentry/browser";
import { isPlatformBrowser } from "@angular/common";

declare let L: any;
@Component({
  selector: "app-twitter",
  templateUrl: "./twitter.component.html",
  styleUrls: ["./twitter.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialTwitterComponent implements OnInit {
  position: number = 0;

  active: boolean = false;
  loading: boolean = true;
  classBuilder: string = "";
  subscription: Subscription;
  displayLimit: number = 6;
  activatePadding: boolean = false;
  moduleInfo: string;
  isStock: string = "";
  editOn: boolean = false;
  dragActive: boolean = false;
  isBrowser$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  twitterInfos: TwitterInterface;
  textColor: string = "";
  titleSize: string = "";
  backgroundColor: string = "";
  twitterLink: string = "";
  title: string = "";
  data;

  constructor(@Inject(PLATFORM_ID) public platformId) {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "TwitterComponent");
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser$.next(true);
    }
    this.twitterInfos = this.data;
    this.textColor = this.twitterInfos.textColor;
    this.twitterLink = this.twitterInfos.twitterLink;
    this.backgroundColor = this.twitterInfos.backgroundColor;
    this.titleSize = this.twitterInfos.titleSize;
    this.title = this.twitterInfos.title;
  }
}
